<template>
  <footer class="brand-footer">
    <div class="container-fixed">
      <div v-if="showLangSelection" class="row brand-footer-bar brand-footer-bar-condensed">
        <div class="col-l-12 col-s-12">
          <ul data-test="language" class="nav brand-footer-nav text-l-right text-s-center">
            <li v-for="lang in languages" :key="lang" :class="{ active: lang === $i18n.locale }">
              <a :data-test="'language_' + lang" href="#" :aria-current="lang === $i18n.locale ? true : null" @click.prevent="changeLanguage(lang)">{{
                $t('common.lang_' + lang)
              }}</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="row brand-footer-bar hidden-xl hidden-l hidden-m">
        <div class="col-l-3 col-m-2 col-s-12">
          <div class="brand-logo">
            <router-link :to="{ name: HOME }">
              <img src="@/assets/telekom-brand-and-design/images/telekom-logo.svg" alt="Telekom Logo" />
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="brand-footer-separator hidden-xl hidden-l hidden-m"></div>
    <div class="container-fixed">
      <div v-if="showLangSelection" class="row hidden-s hidden-xs">
        <div class="col-l-12">
          <div class="brand-footer-separator"> </div>
        </div>
      </div>
      <div class="row brand-footer-bar">
        <div class="col-l-3 col-m-2 hidden-s hidden-xs">
          <div v-if="isTelekom" class="brand-logo">
            <img v-if="disableLogoLink" src="@/assets/telekom-brand-and-design/images/telekom-logo.svg" alt="Telekom Logo" />
            <router-link v-else :to="{ name: HOME }">
              <img src="@/assets/telekom-brand-and-design/images/telekom-logo.svg" alt="Telekom Logo" />
            </router-link>
          </div>
        </div>
        <div class="col-m-12 hidden-xl hidden-l hidden-m text-center text-bright">
          <div class="brand-footer-bar-text" v-html="$t('common.copyright')"></div>
        </div>
        <div class="col-l-6 col-m-8 col-s-12">
          <ul class="nav brand-footer-nav brand-footer-nav-bright text-center">
            <slot name="prepend" />
            <li v-for="n in maxFooterLinks" :key="'footer' + n" v-html="$t('common.footer_link' + n)" />
            <slot name="append" />
          </ul>
        </div>
        <div class="col-l-3 col-m-12 hidden-s hidden-xs text-l-right text-m-center text-bright">
          <div class="brand-footer-bar-text" v-html="$t('common.copyright')"></div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Proxy from '@/proxies/LangProxy';
import { HOME } from '@route-types';

export default {
  name: 'CommonguiFooter',

  props: {
    disableLogoLink: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      HOME,
    };
  },

  computed: {
    showLangSelection() {
      return this.languages.length > 1;
    },

    languages() {
      if (this.availableLanguages !== null) return this.availableLanguages;
      return Object.keys(this.$i18n.messages);
    },

    maxFooterLinks() {
      const max = 10;
      for (let i = 1; i < max; i++) {
        if (!this.$te('common.footer_link' + i)) return i - 1;
      }
      return max;
    },

    ...mapState('system', ['availableLanguages', 'sessionId']),
    ...mapGetters('system', ['isTelekom']),
  },

  methods: {
    async changeLanguage(locale) {
      await new Proxy().set(locale);
      this.$i18n.locale = locale;
      sessionStorage.setItem('languageEvent', `${locale};${this.sessionId}`);
    },
  },
};
</script>
